<template>
    <v-container fill-height class="align-start">
        <loading-overlay :loading="loading"></loading-overlay>

        <v-row v-if="action === 'add-bank' && request">
            <v-col class="text-center">
                <h2>Link your bank</h2>
                <plaid-link
                    v-if="countryPaymentMethod.provider === 'PLAID'"
                    :canAdd="true"
                    :method="countryPaymentMethod.method"
                    :country="request.benefactor_country"
                    :userId="request.benefactor_user_id"
                    oauthRedirectURL="/upr/plaid-oauth-redirect"
                    @loading="onLoading"
                    @loaded="onLoaded"
                    @onFinished="addBank"
                >
                    <v-icon>mdi-plus-thick</v-icon> Add bank account
                </plaid-link>

                <klarna-link
                    v-if="countryPaymentMethod.provider === 'KLARNA'"
                    :userId="request.benefactor_user_id"
                    @loading="onLoading"
                    @loaded="onLoaded"
                    @onFinished="addBank"
                >
                    <v-icon>mdi-plus-thick</v-icon>  Add bank account
                </klarna-link>
            </v-col>
        </v-row>

        <v-row v-if="action === 'accept' && request">
            <v-col class="text-center">
                <request-accept-modal
                    ref="requestAcceptModal"
                    v-model="showTransferModal"
                    :request="request"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import plaidLink from '../components/plaid-link';
import klarnaLink from '../components/klarna-link';

import feeWheel from '../transfers/components/fee-wheel.vue';
import requestDetailsModal from '../requests/request-details-modal.vue';
import requestAcceptModal from './request-accept-modal.vue';

export default {
    components: {
        plaidLink,
        klarnaLink,
        feeWheel,
        requestDetailsModal,
        requestAcceptModal,
    },
    data() {
        return {
            loading: true,
            action: 'initiate',
            countryPaymentMethod: null,
            request: null,
            showTransferModal: false,
        };
    },
    mounted() {
        this.initiate();
    },
    methods: {
        onLoading() {
            this.loading = true;
        },
        onLoaded() {
            this.loading = false;
        },
        async initiate() {
            const { id, hash } = this.$route.params;

            try {
                const { data } = await Vue.backendApi().unregisteredPaymentRequest(id, hash).initiate();
                const {
                  action,
                  request,
                  countryPaymentMethod,
                } = data;

                Vue.set(this, 'request', request);
                Vue.set(this, 'countryPaymentMethod', countryPaymentMethod);
                Vue.set(this, 'action', action);

                if (action === 'upr-status') {
                    this.$router.push({
                        name: 'upr-status',
                        params: {
                            id,
                            hash,
                        },
                    });
                    return;
                }

                if (action === 'accept') {
                    this.getMatcherFee();
                }

                this.$store.dispatch('updateUnregisteredPaymentRequest', request);
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error',
                    text: err,
                });
            } finally {
                this.loading = false;
            }
        },
        async addBank(payload) {
            const { id, hash } = this.$route.params;
            this.loading = true;

            try {
                const { data } = await Vue.backendApi().unregisteredPaymentRequest(id, hash).addBank(payload);

                const {
                  action,
                  request,
                } = data;

                Vue.set(this, 'request', request);
                Vue.set(this, 'action', action);

                if (action === 'upr-status') {
                    this.$router.push({
                        name: 'upr-status',
                        params: {
                            id,
                            hash,
                        },
                    });
                    return;
                }

                if (action === 'accept') {
                    this.getMatcherFee();
                }

                this.$store.dispatch('updateUnregisteredPaymentRequest', request);
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error adding bank',
                    text: err,
                });
            } finally {
                this.loading = false;
            }
        },

        async getMatcherFee() {
            if (!this.request.order) {
                this.showTransferModal = true;
                return;
            }

            const { id, hash } = this.$route.params;
            this.loading = true;

            try {
                const { data } = await Vue.backendApi().unregisteredPaymentRequest(id, hash).getMatcherFee();

                this.showTransferModal = true;
                this.$set(this.request.order, 'matcher_fee_id', data.id);
                this.$set(this.request.order, 'matcher_fee', data.fee);
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error loading matcher\'s fee',
                    text: err,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
